import { render, staticRenderFns } from "./ClientAddresses.vue?vue&type=template&id=5e052464&scoped=true&"
import script from "./ClientAddresses.vue?vue&type=script&lang=js&"
export * from "./ClientAddresses.vue?vue&type=script&lang=js&"
import style0 from "./ClientAddresses.vue?vue&type=style&index=0&id=5e052464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e052464",
  null
  
)

export default component.exports